import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image'
import React from 'react'

const MeasurImage = (
  props: Omit<GatsbyImageProps, 'alt'> & { alt?: string },
) => (
  <GatsbyImage
    alt={props.title ?? ''}
    backgroundColor="transparent"
    loading="lazy"
    {...props}
  />
)

export default MeasurImage
